<template>
    <!-- 奖牌榜 -->
    <div>
        <div class="i-cont">数据统计截止至{{nowDate.replaceAll('-','.')}}</div>
        <div class="medal">
            <div class="title row">
                <div class="col1  t-col">排名</div>
                <div class="col2  t-col">代表队</div>
                <div class="col3  t-col">
                    <img src="../../assets/image/1.png" alt="">
                </div>
                <div class="col4  t-col">
                    <img src="../../assets/image/2.png" alt="">
                </div>
                <div class="col5  t-col">
                    <img src="../../assets/image/3.png" alt="">
                </div>
                <div class="col6  t-col">
                    <img src="../../assets/image/4.png" alt="">
                </div>
            </div>
            <template v-if="medalList.length>0">
                <div class="row" v-for="(item, index) in medalList" :key="index">
                    <div class="col1" v-if="isHome">{{ index+1 }}</div>
                    <div class="col1" v-else>{{ (rankParams.pageNum-1)*rankParams.pageSize + 1+index }}</div>
                    <div class="col2">{{ item.agencyName }}</div>
                    <div class="col3" @click="showDetail(item.agencyName, 1)">{{ item.gold }}</div>
                    <div class="col4" @click="showDetail(item.agencyName, 2)">{{ item.silver }}</div>
                    <div class="col5" @click="showDetail(item.agencyName, 3)">{{ item.bronze }}</div>
                    <div class="col6" @click="showDetail(item.agencyName, 0)">{{ item.gold + item.silver + item.bronze }}</div>
                </div>
                <div class="pagination" v-if="!isHome">
                    <!-- <a-pagination :default-current="rankParams.pageNum" :total="total" @change="handlePage" :pageSize="rankParams.pageSize"/> -->
                </div>
            </template>
            <template v-else>
                <a-empty class="empty">
                    <span slot="description">暂无数据</span>
                </a-empty>
            </template>
        </div>
        <a-modal v-model="visible" title="奖牌详情" width="250px" @ok="handleOk">
          <div v-for="(item, index) in dataMap" :key="index">
            <p><b>{{ index }}</b></p><p v-for="(it, ind) in dataMap[index]" :key="ind">{{ ind }}：{{ dataMap[index][ind] }}枚</p>
          </div>
          <div v-if="Object.keys(dataMap).length === 0"><span v-if="rankNumParams.type > 0">第{{ rankNumParams.type }}名</span>没有获奖数据!</div>
        </a-modal>
    </div>

</template>

<script>
import {filterTime} from '@comm/utils/handleDateTime'

export default {
  props: {
    medalList: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    rankParams: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    rankNumParams: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    total: {
      type: Number,
      default: 0
    },
    isHome: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      visible: false,
      dataMap: {},
      nowDate:filterTime(),
      medalList1: [{
        unitName: '重庆市六十五中',
        gold: 10,
        silver: 6,
        bronze: 10
      },{
        unitName: '重庆市育才中学',
        gold: 5,
        silver: 6,
        bronze: 10
      },{
        unitName: '重庆市金茂小学',
        gold: 4,
        silver: 16,
        bronze: 10
      },{
        unitName: '重庆市巴蜀小学',
        gold: 3,
        silver: 6,
        bronze: 3
      },{
        unitName: '重庆市田家炳中学',
        gold: 2,
        silver: 2,
        bronze: 20
      }],
    }
  },
  methods: {
    rowClick (item) {
      this.$emit('rowClick', item)
    },
    handlePage (page, pageSize){
      this.$emit('handlePage', page, pageSize)
    },
    showDetail (agencyName, type) {
      this.visible = true
      this.rankNumParams.agencyName = agencyName
      this.rankNumParams.type = type
      this.medalProgramNum()
    },
    handleOk (e) {
      console.log(e)
      this.visible = false
    },
    //所有分组
    async medalProgramNum () {
      try {
        let res =await this.$api.district.medalProgramNum(this.rankNumParams)
        if(res.status==0){
          this.dataMap = res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.i-cont{
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 10px;
}
.medal{
    border: 4px solid #124584;
    box-sizing: border-box;
    border-radius: 10px;
    width: 1200px;
    margin: 0 auto;
    .row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        height: 60px;
        line-height: 60px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #ACD0FD;
        cursor: pointer;
        .col1{
            width: 120px;
            height: 100%;
             box-sizing: border-box;
        }
        .col2{
            width: 280px;
            height: 100%;
            text-align: left;
            padding-left: 10px;
            box-sizing: border-box;
            border-left: 1px solid #ACD0FD;
            border-right: 1px solid #ACD0FD;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .col3{
            width: 15%;
             height: 100%;
              box-sizing: border-box;
        }
        .col4{
            width: 15%;
             height: 100%;
              box-sizing: border-box;
                border-left: 1px solid #ACD0FD;
             border-right: 1px solid #ACD0FD;
        }
        .col5{
            width: 15%;
             height: 100%;
              box-sizing: border-box;
             border-right: 1px solid #ACD0FD;
        }
        .col6{
            width: 15%;
            height: 100%;
            box-sizing: border-box;
        }
        .t-col{
            border: none;
            img{
                width: 60px;
                height: 60px;
            }
        }
    }
    .title{
        height: 76px;
        line-height: 80px;
        background-color: #124584;
        color: #ffffff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        .col2{
            text-align: center;
        }
    }
    .pagination{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin:20px 0 ;
    }
    .empty{
        min-height: 400px;
        padding-top: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/components/home/Medal.vue